/**
 * View-state for the Copy Packing List dialog (T-001).
 */

export type CopyPackingListViewState = 'loading' | 'error' | 'empty' | 'list';

export interface DeriveCopyPackingListViewStateArgs {
    eventsLoading: boolean;
    packingListsLoading: boolean;
    packingListsError: unknown;
    eventCount: number;
}

/**
 * Map query flags + selectable event count to dialog view state.
 * Loading wins over error; stale successful data (eventCount > 0) wins over a later error.
 */
export function deriveCopyPackingListViewState({
    eventsLoading,
    packingListsLoading,
    packingListsError,
    eventCount,
}: DeriveCopyPackingListViewStateArgs): CopyPackingListViewState {
    if (eventsLoading || packingListsLoading) {
        return 'loading';
    }
    if (packingListsError != null && eventCount === 0) {
        return 'error';
    }
    if (eventCount > 0) {
        return 'list';
    }
    return 'empty';
}
